import React, { useState } from "react";
import { useLocation } from "@reach/router";
import { useForm } from "react-hook-form";
import Loader from "components/loader";
import { useGetInTouchLocation } from "hooks/Forms/useGetInTouchLocation";
import ThankYouPopup from "components/popup/thankYouPopup";

function MultilingualBanner() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { status, mutateAsync } = useGetInTouchLocation();

  const onSubmit = (data) => {
    const postData = {
      name: data.name,
      email: data.email,
      message: data.message,
      pagelink: location.href,
    };
    mutateAsync(postData).then((_) => {
      reset();
      setOpen(true);
    });
  };
  return (
    <div>
      <div className="bg-bannerNew bg-no-repeat bg-cover bg-center py-10">
        <div className="flex flex-col xl:flex-row w-full px-3 sm:px-0 sm:w-11/12 lg:w-10/12 2xl:w-9/12 max-w-7xl mx-auto justify-between">
          <div className="flex flex-col max-w-[600px]">
            <h1 className="text-[35px] sm:text-[40px] leading-[55px] font-bold font-secondary text-midBlue mb-5 sm:mb-8">
              Multilingual SEO Services
              <br />
              {/* For Website Localization */}
            </h1>
            {/* <h1 className="text-[35px] sm:text-[40px] leading-[55px] font-bold font-secondary text-midBlue mb-5 sm:hidden">
              Multilingual SEO Services For Website Localization
            </h1> */}
            <p className="text-base leading-6 font-opensans text-midBlue mb-6 hidden sm:block">
              Take your website to the top of search pages across the world,
              without a doubt in mind. Drive more organic traffic to your
              foreign-language pages and become visible on the world stage, with
              Tomedes as your partner in language.
            </p>
            <p className="text-base leading-6 font-opensans text-midBlue mb-6 hidden sm:block">
              Our multilingual SEO services are the keystone of our
              comprehensive website localization suite, which can be tailored to
              fit your project’s specific needs. Contact us now, and our agent
              will connect you with one of our SEO experts to get you started.
            </p>
            <p className="text-base leading-6 font-opensans text-midBlue mb-6 sm:hidden">
              Drive more organic traffic to your foreign-language website pages
              and become visible on the world stage, with Tomedes as your
              partner in language.
            </p>
            <div className="hidden xl:flex flex-col gap-y-4 pt-[10px]">
              <div className="flex gap-x-3 items-center">
                <img
                  src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/call-center.svg"
                  alt=""
                  className="w-9"
                />
                <span className="font-secondary text-[20px] text-white">
                  Available Online 24/7
                </span>
              </div>
              <div className="flex gap-x-3">
                <img
                  src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/badge.svg"
                  alt=""
                  className="w-9"
                />
                <span className="font-secondary text-[20px] text-white">
                  1-Year Guarantee
                </span>
              </div>
              <div className="flex gap-x-3">
                <img
                  src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/Group.svg"
                  alt=""
                  className="w-9"
                />
                <span className="font-secondary text-[20px] text-white">
                  95,000 Business Customers
                </span>
              </div>
            </div>
          </div>
          <ThankYouPopup open={open} setOpen={setOpen} />
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="h-full px-6 sm:px-10 pt-6 sm:pt-8 w-[324px] sm:w-[409px] bg-[#F5F5F5] pb-6 sm:pb-8 self-start"
            style={{
              boxShadow: "5px 5px 50px #004C7430",
              borderRadius: "20px",
            }}
          >
            <div className="text-[22px] sm:text-[26px] font-semibold font-secondary text-orange">
              Get in Touch
            </div>
            <div className="flex flex-col pt-4">
              <input
                type="text"
                name="name"
                className="pl-2 py-2 rounded mt-2"
                placeholder="Name"
                style="border: 1px solid #D8D8D8;"
                {...register("name", {
                  required: true,
                })}
              />
              {errors.name && (
                <span className="text-red text-sm mb-[10px] font-sans mt-2">
                  This field is required.
                </span>
              )}

              <input
                type="text"
                placeholder="Email"
                name="email"
                className="pl-2 py-2 rounded mt-2"
                style="border: 1px solid #D8D8D8;"
                {...register("email", {
                  required: true,
                })}
              />
              {errors.email && (
                <span className="text-red text-sm font-sans mb-[10px] mt-2">
                  This field is required.
                </span>
              )}

              <textarea
                type="text"
                name="message"
                className="pl-2 py-2 rounded mt-2 min-h-[153px]"
                placeholder="Tell us more about your needs"
                style="border: 1px solid #D8D8D8;"
                {...register("message")}
              />
              {errors.message && (
                <span className="text-red text-sm font-primary mb-[10px] ">
                  This field is required
                </span>
              )}

              <button className="bg-orange text-white text-[18px] font-sans py-3 mt-4">
                {status === "loading" ? <Loader /> : "SUBMIT"}
              </button>
            </div>
          </form>
          <div className="flex flex-col gap-y-4 pt-[10px] mt-8 xl:hidden">
            <div className="flex gap-x-3 items-center">
              <img
                src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/call-center.svg"
                alt=""
                className="w-9"
              />
              <span className="font-secondary text-[20px] text-white">
                Available Online 24/7
              </span>
            </div>
            <div className="flex gap-x-3">
              <img
                src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/badge.svg"
                alt=""
                className="w-9"
              />
              <span className="font-secondary text-[20px] text-white">
                1-Year Guarantee
              </span>
            </div>
            <div className="flex gap-x-3">
              <img
                src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/Group.svg"
                alt=""
                className="w-9"
              />
              <span className="font-secondary text-[20px] text-white">
                95,000 Business Customers
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MultilingualBanner;
